import React, { useContext } from 'react';
import styled from 'styled-components';

import CanvasContext from '../../contexts/CanvasContext';
import DashboardContext from '../../contexts/DashboardContext';
import WallboardContext from '../../contexts/WallboardContext';
import DatePickerTriggerContext from '../../contexts/DatePickerTriggerContext';
import ErrorBoundary from '../Common/ErrorBoundary';
import { Z_INDEX } from '../../constants';
import DateFilterTrigger from '../DashboardGadgetBottomBar/DateFilterTrigger';

const Wrapper = styled.div<{ isEditing: boolean }>`
  height: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;

  .showOnMouseOver {
    opacity: 0;
    width: 0;
  }

  &:hover {
    .showOnMouseOver {
      opacity: 1;
      width: unset;
    }

    .autoHideTrigger {
      opacity: 1;
      pointer-events: auto;
    }
  }

  .autoHideFooter {
    position: absolute;
    bottom: 0px;
    z-index: ${Z_INDEX.CANVAS_CARD_FOOTER};
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.4s ease;
  }

  .autoHideTrigger {
    position: absolute;
    bottom: 4px;
    left: 4px;
    z-index: ${Z_INDEX.CANVAS_CARD_FOOTER};
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.4s ease;
  }
`;

const Header = styled.div`
  position: relative;
  height: 40px;
  padding: 0px 8px;
  border-bottom: 1px solid var(--color-border-secondary);
`;
const Main = styled.div<{ isContentWithoutPadding?: boolean }>`
  flex: 1;
  flex-shrink: 1;
  overflow-y: auto;
`;

const Footer = styled.div<{ isAbsolute?: boolean }>`
  padding: 8px;
  width: 100%;
  ${(props) =>
    props.isAbsolute &&
    `
      position: absolute;
      bottom: 0px;
      z-index: ${Z_INDEX.CANVAS_CARD_FOOTER};
    `}
`;

const CanvasCard = ({
  topBar,
  content,
  bottomBar,
  isBottomBarAbsolute,
  isContentWithoutPadding,
}: {
  topBar?: JSX.Element | JSX.Element[];
  content: JSX.Element | JSX.Element[];
  bottomBar?: JSX.Element | JSX.Element[];
  isBottomBarAbsolute?: boolean;
  isContentWithoutPadding?: boolean;
}) => {
  const { isWallboard } = useContext(WallboardContext);
  const { isEditing } = useContext(CanvasContext);
  const { dashboard } = useContext(DashboardContext);
  const { isActive } = useContext(DatePickerTriggerContext);
  const isAutoHideBottomBar = !!dashboard?.isAutoHideBottomBar;

  const isFooterAutoHiding = isAutoHideBottomBar && !isActive;

  return (
    <Wrapper isEditing={isEditing}>
      {/* Class names let hosts with their own chrome (e.g. Studio) hide these */}
      {topBar && <Header className="canvas-card-header">{topBar}</Header>}
      <Main
        className="hiding-scrollbar"
        isContentWithoutPadding={isContentWithoutPadding || isWallboard}
      >
        <ErrorBoundary isRetryable>{content}</ErrorBoundary>
      </Main>
      {!isWallboard && !!bottomBar && (
        <Footer
          isAbsolute={isBottomBarAbsolute}
          className={
            isFooterAutoHiding
              ? 'canvas-card-footer autoHideFooter'
              : 'canvas-card-footer'
          }
        >
          {bottomBar}
        </Footer>
      )}
      {!isWallboard && !!bottomBar && isAutoHideBottomBar && !isActive && (
        <div className="autoHideTrigger">
          <DateFilterTrigger />
        </div>
      )}
    </Wrapper>
  );
};

export default CanvasCard;
